/* eslint-disable max-len */
import { getHostName } from 'app/utilities/Utils';
import React from 'react';
import { Row, Col } from 'react-bootstrap';

function StaticContent() {
  // const [show, setShow] = useState(false);
  return (
    <div className="">
      <Row
        className="mx-0"
      >
        <Col
          xs={24}
          className="mb-2"
        >
          <h1>
            LoveLocal - Shop everything you need from trusted Kirana stores
          </h1>
        </Col>
        <Col
          xs={24}
        >
          <div
            className="mx-0 mt-2 text-secondary"
          >
            Can anyone understand your daily
            {' '}
            <a rel="noopener noreferrer" href={`${getHostName()}pc/grains-oil-and-masala`} target="_blank">
              grains
            </a>
            ,
            {' '}
            <a rel="noopener noreferrer" href={`${getHostName()}pc/health-and-medicine`} target="_blank">
              medicines
            </a>
            , and
            {' '}
            <a rel="noopener noreferrer" href={`${getHostName()}pc/monthly-samaan`} target="_blank">
              grocery
            </a>
            {' '}
            needs better than your local Kirana stores?
            We don’t think so!
            There’s nothing as convenient as getting
            &nbsp;your monthly or daily ’rashan’ from your nearest general store. Why?
          </div>
        </Col>
        <Col
          xs={24}
        >
          <div
            className="mx-4 mt-3 text-secondary"
          >
            <ul>
              <li>
                You already know the general store and the retailer
              </li>
              <li>
                Great deals on grocery items are always available for customers.
              </li>
              <li>
                You trust the quality of the every product
              </li>
            </ul>
          </div>
        </Col>
        <Col
          xs={24}
        >
          <div
            className="mx-0 mt-2 text-secondary"
          >
            When searching for &quot;take me to the nearest grocery store&quot;
            for your monthly grains, local kirana stores are the ideal destination.
            Or are you tired of looking for “how late is the closest grocery store open”, then we’ve got you covered. These general stores have been delivering your essentials like grocery items,
            {' '}
            <a rel="noopener noreferrer" href={`${getHostName()}pc/fruits-and-vegetables`} target="_blank">
              vegetables
            </a>
            ,
            {' '}
            <a rel="noopener noreferrer" href={`${getHostName()}pc/fruits-and-vegetables/fresh-fruits`} target="_blank">
              fruits
            </a>
            {' '}
            login & more for many years
          </div>

          <div
            className="mx-0 mt-2 text-secondary"
          >
            Just add your grocery items to the cart and it will be delivered! LoveLocal is a way to make this experience of
            {' '}
            <b className="text-dark">online shopping</b>
            {' '}
            seamless and efficient. You can retain your relationship with your local kirana stores while you shop online.
            All you need is an
            {' '}
            <a rel="noopener noreferrer" href="https://apps.apple.com/in/app/lovelocal-buy-online-grocery/id6443932475" target="_blank">
              App
            </a>
            {' '}
            on your mobile phone. We have designed this app to provide you with easy access to all the nearest Kirana stores with just a few clicks and navigation. From grains,
            <a rel="noopener noreferrer" href={`${getHostName()}pc/fruits-and-vegetables`} target="_blank">
              oils
            </a>
            ,
            {' '}
            <a rel="noopener noreferrer" href={`${getHostName()}pc/fruits-and-vegetables/fresh-fruits`} target="_blank">
              masalas
            </a>
            {' '}
            to fruit shop near me - LoveLocal covers all your daily essentials.
          </div>

          <div
            className="mx-0 mt-2 text-secondary"
          >
            LoveLocal has the largest catalogue with over 55,000 products across 145
            {' '}
            <a rel="noopener noreferrer" href={`${getHostName()}pc`} target="_blank">
              categories
            </a>
            {' '}
            .
            And the best part? These products come from your favourite kirana stores with the added convenience of online shopping. If you are someone who always says, “I only purchase from a
            <b className="text-dark">
              &nbsp;fruit shop near me
            </b>
            ”, then your trusted Kirana stores have got you covered.
          </div>

          <div
            className="mx-0 mt-2 text-secondary"
          >
            Currently, LoveLocal delivers to 35+ cities in 1300+ pin codes across India. 100,000+ Local retailers have registered on the platform. 1,000,000+ local shoppers use the LoveLocal platform for daily essentials shopping. LoveLocal, gives you access to quality products from grocery items to fruits login to your trusted local retailers.
          </div>

          <div
            className="mx-0 mt-2 text-secondary"
          >
            <b className="text-dark">What are the Benefits of Shopping from LoveLocal?</b>
            <div>
              Besides the fact that you will be supporting your
              {' '}
              <a rel="noopener noreferrer" href={`${getHostName()}shops`} target="_blank">
                local kirana stores
              </a>
              {' '}
              and will no more need to Google
              {' '}
              <b className="text-dark">&quot;take me to the nearest grocery store&quot;</b>
              {' '}
              or
              {' '}
              <b className="text-dark">“how late is the closest grocery store open”</b>
              {' '}
              multiple times by ordering from your nearest general stores on LoveLocal; you will get the following benefits:
            </div>
          </div>
        </Col>

        <Col
          xs={24}
        >
          <div
            className="mx-4 mt-3 text-secondary"
          >
            <ol>
              <li>
                <b className="text-dark">Good quality products - </b>
                Shopping on LoveLocal is like taking a walk and bringing your daily essentials from the next-door retailer you have known all your life. Only, the process is more convenient and time-saving now. Since you already know the shopkeepers, you can blindly trust the quality of the products.
              </li>
              <li>
                <b className="text-dark">Easy payments - </b>
                Since we’re going cashless, paying cash every time you go to the Kirana store is difficult. However, with LoveLocal, you get all modes of payment--online, UPI, as well as cash.
              </li>
              <li>
                <b className="text-dark">A choice between doorstep delivery & pickup - </b>
                With LoveLocal, all you have to do is select your products and buy from the comfort of your home. Kirana stores will deliver your products to your house in the shortest delivery time. Or if you choose to pick it up from the store, we enable that too.
              </li>
            </ol>
          </div>
        </Col>

        <Col
          xs={24}
        >
          <div
            className="mx-4 mt-3 text-secondary"
          >
            <ol>
              <li>
                <b className="text-dark">
                  <a rel="noopener noreferrer" href={`${getHostName()}pc/dry-fruits-oils-and-masala`}>Grains, Oils & Masala </a>
                  :
                </b>
                Now you don’t have to wait for chhotu to go and get your daal or wait until you find someone at the &quot;nukkad&quot; to help you bring some last-minute masala. Get your daal, rice, spices, and other grocery items from your local Kirana stores on LoveLocal. Online grocery shopping was never this easy.
              </li>
              <li>
                <b className="text-dark">
                  <a rel="noopener noreferrer" href={`${getHostName()}pc/pharma-and-otc-products`}>Health & Medicines </a>
                  :
                </b>
                Tired of searching for &quot;medical stores near me&quot; or &quot;pharmacy near me&quot; ? Worry not, because we have got you covered. You can buy your regular medicines, face masks, and hand sanitisers from your nearby pharmacy on LoveLocal. Online medicine orders have increased ever since the lockdowns and we encourage you to shop online too.
              </li>
              <li>
                <b className="text-dark">
                  <a rel="noopener noreferrer" href={`${getHostName()}pc/dairy-bread-and-eggs`}>Dairy </a>
                  &
                  <a rel="noopener noreferrer" href={`${getHostName()}pc/meat-and-seafood`}> Meat</a>
                  :
                </b>
                No more waiting for someone to bring the milk carton or the fresh chicken because they are all here on LoveLocal.
              </li>
              <li>
                <b className="text-dark">
                  <a rel="noopener noreferrer" href={`${getHostName()}pc/cleaning-essentials`}>Household & Cleaning </a>
                  :
                </b>
                It’s okay if you forgot to get the toilet cleaner (psst...we all do!). Just add it to your LoveLocal cart and keep your house clean and sanitised.
              </li>
            </ol>
          </div>
          <div
            className="mx-4 mt-3 text-secondary"
          >
            In addition to the above categories, we also offer collections of fruits, vitamin d vegetables, dry fruits, sweets, daily snacks, beverages, and essentials to ensure that you have everything you need. Whether you want to shop for vitamin d vegetables or products from these categories or looking for “vegetables shops near me”, you need to look no further your Kirana stores are now online!
          </div>

          <div
            className="mx-4 mt-3 text-secondary"
          >
            <b className="text-dark">
              We’re India’s Largest Online Catalogue of Daily Essentials
            </b>
            <div>
              LoveLocal believes in empowering local kirana stores retailers by bringing them closer to their customers through online shopping. Simultaneously, it also aims to give consumers the best experience by bringing a wide variety of products across categories.
            </div>
            <div>
              You now can stop looking for “how late is the closest grocery store open”, or “vitamins d vegetables” or “vegetables shop near me” or “fruit shop near me” anywhere else but LoveLocal. The platform is available in major metropolitan cities such as
              {' '}
              <a rel="noopener noreferrer" href={`${getHostName()}india/mumbai`}>Mumbai </a>
              , Bengaluru, Delhi, Hyderabad, and Kolkata. Also available in smaller cities like Dehradun, Muzaffarpur, and Guwahati. The platform covers all towns and areas in the country.
            </div>
            <div>
              We designed our seamless shopping interface to give you a tailored experience that you can only get from your local Kirana stores retailers. At LoveLocal, we believe shopping daily-essentials is personal, and you deserve nothing less than that.
            </div>
            <div>
              So
              <a rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=chotelal.mpaani.com.android.chotelal"> install </a>
              the LoveLocal app now and meet your local stores online. They are ready to tap into the future of local shopping to deliver you the best. Are you ready too?
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default StaticContent;
